import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Tag from './model';

export const fetchTags = institutionId => {
    return RESTClient.getAuthenticatedObservable('v2/tags', {institutionId}).map(data => ({
        tags: List(data.map(Tag.fromAPI)),
    }));
};
